'use strict'

function init() {

	var slides = $('.mastheadSlide');
	var titles = $('.slide__title');

	function slideLeft() {
		changeSlide(-1, 'slide--right', 'slide--left');
	}

	function slideRight() {
		changeSlide(1, 'slide--left', 'slide--right');
	}
	function changeSlide(direction, classToSlideOff, classToPrepareToBringIn) {
		// Current slide
		var active = $('.slide--active');
		var lastIndex = slides.index(active);

		// Next slide
		var nextIndex = lastIndex + direction;

		if (nextIndex >= slides.length) {
			nextIndex = 0;
		} else if (nextIndex < 0) {
			nextIndex = slides.length - 1;
		}
		var next = slides.eq(nextIndex);

		// We use two frames
		// 1) Prepare next slide
		// 2) Make transition
		// (Can't do on these in the same frame because if we do the prepare won't happen before the change happens.
		//		NOTE: we can't do any work here. If you try to do prepare here and next frame change, in FF it will mess
		//		up if you hit the next button really quick. I assume FF runs the requestAnimationFrame right away with
		// 		the frame we are in if.. i assume... not that far into the frame?)
		window.requestAnimationFrame(function() {
			// Prepare next slide to come in by moving to other side
			next.removeClass('slide--transitioning');
			next.addClass(classToPrepareToBringIn);
			next.removeClass(classToSlideOff);

			// Make transition on next frame
			window.requestAnimationFrame(function() {
				// No longer active and slide off to left
				active.addClass('slide--transitioning');
				active.removeClass('slide--active');
				active.addClass(classToSlideOff);

				// Next slide now active and slide in from right
				next.addClass('slide--transitioning');
				next.removeClass(classToPrepareToBringIn);
				next.addClass('slide--active');

				// Auto progress
				startAutoProgress();

				// Change title
				$('.slide__title--active').removeClass('slide__title--active');
				// DEBUG: console.log('Next Slide: ' + nextIndex + '\nTotal Slides: ' + titles.length);
				titles.eq(nextIndex).addClass('slide__title--active');
			});
		});
	}

	var slideAutoProgressTimeoutID;
	function startAutoProgress() {
		clearTimeout(slideAutoProgressTimeoutID);
		slideAutoProgressTimeoutID = setTimeout(slideRight, 4000);
	}
	if ($('.mastheadSlider').length) {
		var slideRightControl = document.querySelector('.mastheadSlider__arrowRightWrapper');
		var slideLeftControl = document.querySelector('.mastheadSlider__arrowLeftWrapper');

		startAutoProgress();
		slideRightControl.addEventListener('click', slideRight, false);
		slideLeftControl.addEventListener('click', slideLeft, false);
	}
}

var MastheadSlider = {
	init: init
}

module.exports = MastheadSlider;
